import Image from 'next/image'
import React from 'react'

export const BidftaPlusBenefits = () => {
  return (
    <div className="px-2 flex flex-col gap-y-12 md:gap-y-16">
      <div className="text-center text-bidfta-gray-white text-50 font-extrabold">
        <h3 className="uppercase text-35 md:block hidden font-extrabold">
          Member benefits
        </h3>
        <h3 className="uppercase text-24 text-bidfta-yellow-legacy font-bold block md:hidden">
          BidFTA+ MEMBER BENEFITS
        </h3>
      </div>
      <div className="flex flex-wrap gap-y-8 justify-evenly flex-col sm:flex-row">
        <div className="flex flex-col items-center gap-5 sm:w-1/2 lg:w-auto">
          <div>
            <Image
              src={'/images/bidftaPlus/EarlyAuctionPickupIcon.svg'}
              alt={'EARLY PICK UP HOURS*'}
              width={150}
              height={150}
            />
          </div>
          <div className="text-bidfta-gray-white flex flex-col justify-center items-center text-center">
            <h3 className="uppercase md:text-24 text-16 p-0 font-bold">
              {'EARLY PICK UP HOURS*'}
            </h3>
            <div className="w-60">
              <p className="text-12 leading-6 md:text-16 text-16 my-4 font-medium">
                Save time and avoid the crowd with exclusive early pick up
                hours.
              </p>
              <p className="text-10 md:text-16 font-semibold italic text-bidfta-yellow-legacy">
                *Available at participating pick up locations
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center gap-5">
          <div>
            <Image
              src={'/images/bidftaPlus/MembersOnlyAuctionsIcon.svg'}
              alt={'members only auctions'}
              width={150}
              height={150}
            />
          </div>
          <div className="text-bidfta-gray-white flex flex-col justify-center items-center text-center ">
            <h3 className="uppercase md:text-24 text-16 p-0 font-bold">
              {'members only auctions'}
            </h3>
            <div className="w-60">
              <p className="text-12 leading-6 md:text-16 text-16 my-4 font-medium">
                Exclusive access to Members Only Auctions curated specifically
                for BidFTA+ members.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center gap-5">
          <div>
            <Image
              src={'/images/bidftaPlus/CustomAlertsIcon.svg'}
              alt="Custom Alerts*"
              width={150}
              height={150}
            />
          </div>
          <div className="text-bidfta-gray-white flex flex-col justify-center items-center text-center ">
            <h3 className="uppercase md:text-24 text-16 p-0 font-bold">
              {'Custom Alerts*'}
            </h3>
            <div className="w-60">
              <p className="text-12 leading-6 md:text-16 text-16 my-4 font-medium">
                Create custom searches and receive notifications when something
                from your search is added to an auction
              </p>
              <p className="text-10 md:text-16 font-semibold italic text-bidfta-yellow-legacy">
                *Official BidFTA mobile-app required for alerts
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
